import React from "react";
import { AppRoutes } from "./routes";

/**
 * PublicApp — rendered for unauthenticated public paths (/login, /public/...).
 * No Navbar, no SystemDataInitializer, no useKeepAlive, no agent state.
 */
const PublicApp: React.FC = () => <AppRoutes />;

export default PublicApp;
